export default {"src":"/_next/static/media/MintRewards.bc876efe.svg","height":447,"width":442};